import React, { useState, useEffect } from "react";
import axios from "axios";
import "./css/ScheduleForm.css"; // Подключаем стили
import config from "../config"; // Импортируем API_URL

const ScheduleForm = ({ groupId, isOpen, onClose, onScheduleAdded }) => {
  const [formData, setFormData] = useState({
    is_even_week: true, // Числитель/Знаменатель
    weekday: "1",
    order: 1,
    start_time: "",
    end_time: "",
    subject: "",
    classroom: "",
    teacher: "",
  });

  const [bellSchedule, setBellSchedule] = useState([]);
  const [existingSchedule, setExistingSchedule] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBellSchedule();
    fetchExistingSchedule();
  }, []);

  const fetchBellSchedule = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${config.API_URL}/bell_schedule`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.length > 0) {
        setBellSchedule(response.data);
        autofillTime(1, "1", response.data);
      }
    } catch (error) {
      console.error("Ошибка загрузки расписания звонков:", error);
    }
  };

  const fetchExistingSchedule = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${config.API_URL}/schedule`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.length > 0) {
        setExistingSchedule(response.data);
      }
    } catch (error) {
      console.error("Ошибка загрузки расписания:", error);
    } finally {
      setLoading(false);
    }
  };

  const autofillTime = (selectedOrder, selectedWeekday, bells = bellSchedule) => {
    const matchedBell = bells.find(
      (bell) => bell.order === Number(selectedOrder) && bell.weekday === Number(selectedWeekday)
    );

    if (matchedBell) {
      setFormData((prev) => ({
        ...prev,
        start_time: matchedBell.start_time,
        end_time: matchedBell.end_time,
      }));
    }
  };

  const autofillTeacherAndClassroom = (selectedSubject) => {
    const matchedSchedule = existingSchedule.find((lesson) => lesson.subject === selectedSubject);
    if (matchedSchedule) {
      setFormData((prev) => ({
        ...prev,
        teacher: matchedSchedule.teacher,
        classroom: matchedSchedule.classroom,
      }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "order") {
      autofillTime(value, formData.weekday);
    }

    if (name === "subject") {
      autofillTeacherAndClassroom(value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    try {
      await axios.post(`${config.API_URL}/schedule/edit/${groupId}`, { schedule: [formData] }, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert("Расписание успешно добавлено!");
      onScheduleAdded();
      onClose();
    } catch (error) {
      console.error("Ошибка при добавлении расписания:", error);
      alert("Ошибка при добавлении расписания!");
    }
  };

  return (
    <div className={`schedule-panel ${isOpen ? "open" : ""}`}>
      <h2 className="second-text">Добавить расписание</h2>

      <form onSubmit={handleSubmit}>
        <div className="schedule-container">
          <div className="schedule-row">
            <label>Числитель/Знаменатель:</label>
            <select name="is_even_week" value={formData.is_even_week} onChange={handleChange}>
              <option value={true}>Числитель (Чётная)</option>
              <option value={false}>Знаменатель (Нечётная)</option>
            </select>
          </div>

          <div className="schedule-row">
            <label>День недели:</label>
            <select name="weekday" value={formData.weekday} onChange={handleChange}>
              <option value="1">Понедельник</option>
              <option value="2">Вторник</option>
              <option value="3">Среда</option>
              <option value="4">Четверг</option>
              <option value="5">Пятница</option>
              <option value="6">Суббота</option>
            </select>
          </div>

          <div className="schedule-row">
            <label>Номер пары:</label>
            <input type="number" name="order" value={formData.order} onChange={handleChange} required />
          </div>

          <div className="schedule-row">
            <label>Начало пары:</label>
            <input type="time" name="start_time" value={formData.start_time} onChange={handleChange} required />
          </div>

          <div className="schedule-row">
            <label>Конец пары:</label>
            <input type="time" name="end_time" value={formData.end_time} onChange={handleChange} required />
          </div>

          <div className="schedule-row">
            <label>Предмет:</label>
            <input type="text" name="subject" value={formData.subject} onChange={handleChange} required />
          </div>

          <div className="schedule-row">
            <label>Аудитория:</label>
            <input type="text" name="classroom" value={formData.classroom} onChange={handleChange} required />
          </div>

          <div className="schedule-row">
            <label>Преподаватель:</label>
            <input type="text" name="teacher" value={formData.teacher} onChange={handleChange} required />
          </div>
        </div>

        <div className="button-group">
          <button className="sliding-button add-shedule-page" type="submit">Добавить</button>
          <button className="sliding-button close-shedule-page" type="button" onClick={onClose}>
            Закрыть
          </button>
        </div>
      </form>
    </div>
  );
};

export default ScheduleForm;
